module.exports = __webpack_public_path__ + "static/brain-36063b80a5ea764776ef525794bfe8c1.png";